import { gql } from "apollo-boost";

export const PROGRAM_MERGE = gql`
mutation ProgramMutate($programData: ProgramInput!) {
  programMutate(programData: $programData) {
    edges {
      node {
        programId
        programName
        programDesc
        startDate
        endDate
        programType
        parentProgramId
        focus
        goals
        structure
        duration
        clubId
        private
      }
    }
  }
}

`;

export const PROGRAM_DELETE = gql`
mutation DeleteProgram($programId: Int!) {
  programDelete(programId: $programId) {
    success
    message
  }
}
`;

export const WORKOUT_MERGE = gql`
mutation MergeWorkout($workoutData: WorkoutInput!) {
  workoutMerge(workoutData: $workoutData) {
      node {        
      workoutId
      workoutDesc
      programId
      startDatetime
      duration
      volume
      dayOfMicrocycle
      videoUrl
      updateSource
    }
  }
}

`;

export const WORKOUT_DELETE = gql`
mutation DeleteProgram($workoutId: Int!) {
  workoutDelete(workoutId: $workoutId) {
    success
    message
  }
}
`;

export const SET_MERGE = gql`
mutation SetMutate($input: SetInput!) {
  setMutate(setData: $input) {
    edges {
      node {
        setId
        setName
        setDesc
        setPurpose
        noOfSets
        noOfRep
        distance
        distanceSum
        stroke
        tag
        setInterval
        timePerDist
        timeTotal
        equipment
        sportType
        activityId
        workoutId
        parentSetId
        isLibrarySet
        order
        videoUrl
        updateDate
        updateSource
      }
    }
  }
}
`;

export const SET_DELETE = gql`
mutation DeleteSet($setId: Int!) {
  setDelete(setId: $setId) {
    success
    message
  }
}
`;

export const WORKOUT_SCHEDULE_MUTATE = gql`
mutation workoutScheduleMutate(
  $seqNo: Int,
  $groupId: Int!,
  $termId: Int!,
  $facilityId: Int!,
  $dayOfWeek: String!,
  $startTime: String!,
  $endTime: String!,
  $workoutType: String!,
  $notes: String,
  $updateSource: String!
) {
  workoutScheduleMutate(programData: {
    seqNo: $seqNo,
    groupId: $groupId,
    termId: $termId,
    facilityId: $facilityId,
    dayOfWeek: $dayOfWeek,
    startTime: $startTime,
    endTime: $endTime,
    workoutType: $workoutType,
    notes: $notes,
    updateSource: $updateSource
  }) {
    edges {
      node {
        seqNo
        groupId
        dayOfWeek
        startTime
        endTime
        workoutType
        facilityId
      }
    }
  }
}
`;

export const WORKOUT_SCHEDULE_DELETE = gql`
mutation workoutScheduleDelete($seqNo: Int!) {
  workoutScheduleDelete(seqNo: $seqNo) {
    success
    message
  }
}
`;
